export default [
  {
    path: '/dashboard/:key?',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {},
  },
];
